import React from "react";
import {Alert, Space} from "antd";
import {Trans} from "react-i18next";

export const Notifications = ({data,fetchConfig})=>{

    const [cfg,setCfg] = React.useState([])

    const load = async ()=>{
        const  rows  = await fetchConfig({schema: 'reg_approval_notify'}) || []
        setCfg(rows)
    }
    React.useEffect(()=>{
        load();
    },[])
    return <React.Fragment>
        <Space direction={"vertical"} key={cfg} className={"notifications"}>
            {cfg.map(({name,title})=>{
                const {moss_registered = false,
                    oss_special_schema_registered = false,
                    ss_nr_want_to_register = false,
                    ss_nr_continue_without_oss = false
                } = data;

                const fc_rep_only = (!oss_special_schema_registered) && (!ss_nr_want_to_register) && ss_nr_continue_without_oss;

                switch (name){
                    case "ei_src_notification":
                        return <React.Fragment>
                            {(data.ei && !data.ei_can_identify_source) && <Alert
                                closable={true}
                                type={'error'}
                                message={<Trans i18nKey={`reg_approval_notify.${name}.title`} defaults={"EI Cannot Identify Source of Goods"}/>}
                                description={<Trans i18nKey={`reg_approval_notify.${name}.desc`} defaults={title}/>}
                            />}
                        </React.Fragment>
                    case "ms_notification":
                        return <React.Fragment>
                            {(data.multiple_sites) && <Alert
                                closable={true}
                                type={'error'}
                                message={<Trans i18nKey={`reg_approval_notify.${name}.title`} defaults={"Multiple Sites Detected"}/>}
                                description={<Trans i18nKey={`reg_approval_notify.${name}.desc`} defaults={title}/>}
                            />}
                        </React.Fragment>
                    case "mi_notification":
                        return <React.Fragment>
                            {(data.multiple_integrations) && <Alert
                                closable={true}
                                type={'error'}
                                message={<Trans i18nKey={`reg_approval_notify.${name}.title`} defaults={"Multiple Integrations Required"}/>}
                                description={<Trans i18nKey={`reg_approval_notify.${name}.desc`} defaults={title}/>}
                            />}
                        </React.Fragment>
                    case "ss_nr_fc_rep_only":
                        return <React.Fragment>
                            {(fc_rep_only) && <Alert
                                closable={true}
                                type={'error'}
                                message={<Trans i18nKey={`reg_approval_notify.${name}.title`} defaults={"FC Representation Only"}/>}
                                description={<Trans i18nKey={`reg_approval_notify.${name}.desc`} defaults={title}/>}
                            />}
                        </React.Fragment>
                    default:
                        return <React.Fragment/>
                }
            })}
        </Space>
    </React.Fragment>
}
